import { isAssignedCountryCallingCode } from "@payair/e-com-common-sdk/phone/CountryCallingCodes"
import { ConsumerPhoneNumberValue } from "../components/phoneNumberInput/ConsumerPhoneNumberValue.model"

const EMAIL_FORMAT =
  /^([a-zA-Z0-9]+(?:[.+_-]+[a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-]+[a-zA-Z0-9]+)*){1,253}\.([a-zA-Z0-9]+(?:\.+[a-zA-Z0-9]+)*)$/
const DUPLICATED_EMAIL_SPECIAL_CHARACTERS = /([.+_-]){2}/
export const CONSUMER_EMAIL_MAX_LENGTH = 255
const DIGITS_ONLY = /^\d+$/
const PHONE_COUNTRY_CODE_MAX_LENGTH = 3
const PHONE_NUMBER_MIN_LENGTH = 4
const PHONE_NUMBER_MAX_LENGTH = 14
const E164_MAX_LENGTH = 15

export type ConsumerPhoneNumberValidationErrorCode = "REQUIRED" | "INVALID_FORMAT" | "INVALID_LENGTH"

export const isConsumerEmailValid = (emailAddress: string): boolean => {
  if (
    emailAddress.length > CONSUMER_EMAIL_MAX_LENGTH ||
    !EMAIL_FORMAT.test(emailAddress) ||
    DUPLICATED_EMAIL_SPECIAL_CHARACTERS.test(emailAddress)
  ) {
    return false
  }

  const matchedGroups = emailAddress.match(EMAIL_FORMAT)
  return Boolean(matchedGroups?.length === 4 && matchedGroups[2].length < 254 && matchedGroups[3].length < 254)
}

export const getConsumerPhoneNumberValidationError = (
  value: ConsumerPhoneNumberValue
): ConsumerPhoneNumberValidationErrorCode | undefined => {
  const { countryCode, phoneNumber } = value
  if (!countryCode || !phoneNumber) {
    return "REQUIRED"
  }

  if (
    !DIGITS_ONLY.test(countryCode) ||
    countryCode.length > PHONE_COUNTRY_CODE_MAX_LENGTH ||
    !isAssignedCountryCallingCode(countryCode) ||
    !DIGITS_ONLY.test(phoneNumber)
  ) {
    return "INVALID_FORMAT"
  }

  if (
    phoneNumber.length < PHONE_NUMBER_MIN_LENGTH ||
    phoneNumber.length > PHONE_NUMBER_MAX_LENGTH ||
    countryCode.length + phoneNumber.length > E164_MAX_LENGTH
  ) {
    return "INVALID_LENGTH"
  }

  return undefined
}

export const isConsumerPhoneNumberValid = (value: ConsumerPhoneNumberValue): boolean =>
  getConsumerPhoneNumberValidationError(value) === undefined
